import { observable } from "mobx";
import { Type } from "class-transformer";
import CreditExposureType from "./creditExposureType";
import CreditExposureState from "./creditExposureState";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CreditExposureResponse {
  id!: string;

  @observable
  @Type(() => Date)
  validSinceDate!: Date;

  @observable
  @Type(() => Date)
  validUntilDate!: Date;

  @observable
  state!: CreditExposureState;

  @observable
  type!: CreditExposureType;

  @observable
  description!: string;

  @observable
  amount!: number;
}
